import React, { useEffect, useMemo, useState } from "react";
import CustomTab from "@/components/dataTableComponents/CustomTab";
import { Formik, Form, ErrorMessage } from "formik";
import { Box, Button, CircularProgress } from "@mui/material";
import * as Yup from "yup";
import FormikRadioGroup from "@/components/forms/FormikRadioGroup";
import FormikFileUpload from "@/components/forms/FormikFileUpload";
import { FileUploadOutlinedIcon } from "@/icons";
import FormikDatePicker from "@/components/forms/FormikDatePicker";
import CardContent from "@/pages/attendanceManagement/components/CardContent";
import {
  useFetchEmployeeReportQuery,
  useGetOnSiteAttendanceSampleQuery,
  useOnsiteBulkUploadMutation,
  useProcessByDateMutation,
  useFetchEmployeePunchReportQuery,
} from "@/api/services/attendanceManagement/onsiteAttendance/onsiteAttendance";
import { toast } from "@/components/toastify";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import { Grid } from "@mui/material";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import moment from "moment";
import { StyledButton } from "@/components";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
import { DownloadIcon } from "@/icons";
import * as XLSX from "xlsx";

const OnsiteAttendanceProcess = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [uploadValue, setUploadValue] = useState("daywise");

  const { data: onSiteAttendanceSample = [] } =
    useGetOnSiteAttendanceSampleQuery();

  const [getValues, setvalues] = useState({
    empId: "",
    fromDate: "",
    toDate: "",
  });

  const [punchValues, setPunchValues] = useState({
    fromDate: "",
    toDate: "",
  });

  const [tableRows, setTableRows] = useState([]);

  const {
    data: rowDetails = [],
    refetch,
    isLoading,
  } = useFetchEmployeeReportQuery(
    {
      empId: getValues?.empId,
      fromDate: getValues?.fromDate,
      toDate: getValues?.toDate,
    },
    {
      skip: !(getValues?.empId && getValues?.fromDate && getValues?.toDate),
    }
  );
  useEffect(() => {
    if (getValues?.empId && getValues?.fromDate && getValues?.toDate) {
      refetch();
    }
  }, [getValues, refetch]);

  useEffect(() => {
    if (rowDetails?.data) {
      setTableRows(rowDetails.data);
    }
  }, [rowDetails]);

  // punch attendance fetch
  const [punchTableRows, setPunchTableRows] = useState([]);

  const {
    data: punchRowDetails = [],
    refetch: punchRefetch,
    isLoading: punchLoading,
  } = useFetchEmployeePunchReportQuery(
    {
      fromDate: punchValues?.fromDate,
      toDate: punchValues?.toDate,
    },
    {
      skip: !(punchValues?.fromDate && punchValues?.toDate),
    }
  );
  useEffect(() => {
    if (punchValues?.fromDate && punchValues?.toDate) {
      punchRefetch();
    }
  }, [punchValues, punchRefetch]);

  // useEffect(() => {
  //   if (punchRowDetails?.data) {
  //     setPunchTableRows(punchRowDetails.data);
  //   }
  // }, [punchRowDetails]);

  useEffect(() => {
    if (punchRowDetails?.data) {
      const flatRows = Object.values(punchRowDetails.data).flat();
      setPunchTableRows(flatRows);
    }
  }, [punchRowDetails]);

  const [bulkUploadOnsite] = useOnsiteBulkUploadMutation();
  const [processByDate] = useProcessByDateMutation();
  const { data: fetchAllEmployees } = useFetchCommonData("EMPLOYEES");

  const rows = rowDetails?.data || [];
  const empOptions =
    fetchAllEmployees &&
    fetchAllEmployees.map((item) => ({
      value: item.empId,
      label: item.employeeName,
    }));

  const tabsData = [
    { name: "Onsite Attendance Process" },
    { name: "Attendance Report" },
    { name: "Punch Report" },
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // setPage(1);
  };

  const handleSubmit = async (values, resetForm) => {
    try {
      if (values?.uploadType === "daywise") {
        const response = await processByDate({
          date: moment(values?.date).format("YYYY-MM-DD"),
        }).unwrap();
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${values?.variable || "file"}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        toast("success", "Daywise Processed Successfully");
        resetForm();
        setSubmitting(false);
      } else {
        const formData = new FormData();
        formData.append("file", values?.file);
        const response = await bulkUploadOnsite({ formData }).unwrap();
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${values?.variable || "file"}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        toast("success", "Sample File Download Successful");
        resetForm();
        setUploadValue("daywise");
        setSubmitting(false);
      }
    } catch (error) {
      // const errorMessage = error?.data?.message || error?.message || "Something went wrong.";
      // toast("error", errorMessage);
      // setSubmitting(false);
    }
  };

  const handleSubmitAttedance = async (values, resetForm) => {
    setvalues({
      empId: values?.empId,
      fromDate: moment(values?.fromDate).format("YYYY-MM-DD"),
      toDate: moment(values?.toDate).format("YYYY-MM-DD"),
    });
  };

  const handleSubmitPunchAttedance = async (values, resetForm) => {
    console.log(values);
    setPunchValues({
      fromDate: moment(values?.fromDate).format("YYYY-MM-DD"),
      toDate: moment(values?.toDate).format("YYYY-MM-DD"),
    });
  };

  const uploadType = [
    { value: "daywise", label: "Daywise" },
    { value: "bulkUpload", label: "Bulk Upload" },
  ];

  // Validation Schema using Yup
  const validationSchema = Yup.object().shape({
    uploadType: Yup.string().required("Upload type is required"),
    file: Yup.mixed()
      .required("File is required")
      .test("fileType", "Only .csv files are accepted", (value) => {
        return value && value.name.endsWith(".csv");
      }),
  });
  const validationSchemaDaywise = Yup.object().shape({
    uploadType: Yup.string().required("Upload type is required"),
    date: Yup.date().required("Please Select the Date!"),
  });
  const validationSchemaTwo = Yup.object().shape({
    empId: Yup.string().required("Please Select the Employee!"),
    fromDate: Yup.date().required("Please Select the Date!"),
    toDate: Yup.date().required("Please Select the Date!"),
  });
  const validationSchemaThree = Yup.object().shape({
    // empId: Yup.string().required("Please Select the Employee!"),
    fromDate: Yup.date().required("Please Select the Date!"),
    toDate: Yup.date().required("Please Select the Date!"),
  });
  const validationSchemaToUse = useMemo(() => {
    return uploadValue === "daywise"
      ? validationSchemaDaywise
      : validationSchema;
  }, [uploadValue]);

  const handleReset = (resetForm) => {
    resetForm();
    setvalues({
      empId: "",
      fromDate: "",
      toDate: "",
    });
    setTableRows([]);
  };

  const handlePunchReset = (resetForm) => {
    resetForm();
    setPunchValues({
      fromDate: "",
      toDate: "",
    });
    setPunchTableRows([]);
  };

  const handleDownloadSample = (sampleData, fileName) => {
    if (!sampleData || !(sampleData instanceof Blob)) {
      return;
    }

    // ✅ Check if file is CSV
    if (!fileName.toLowerCase().endsWith(".csv")) {
      console.error("Only CSV format is supported.");
      return;
    }

    // ✅ Force MIME type to CSV
    const csvBlob = new Blob([sampleData], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(csvBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const downloadExcel = () => {
    // Create a new workbook and a worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(
      activeTab === 2 ? punchTableRows : tableRows
    );

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Onsite Attendance");

    // Generate a binary string representation of the workbook
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob from the buffer
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    // Create a download link and trigger the download
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "OnsiteAttendanceReport.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const renderContent = () => {
    const columns =
      activeTab === 2
        ? [
            { field: "empId", headerName: "Employee No", flex: 1 },
            { field: "date", headerName: "Date", flex: 1 },
            { field: "inOut", headerName: "IN/OUT", flex: 1 },
            { field: "punchInOrOut", headerName: "Date IN/OUT Time", flex: 1 },
          ]
        : activeTab === 1
        ? [
            { field: "empId", headerName: "Employee No", flex: 1 },
            { field: "empName", headerName: "Employee Name", flex: 1 },
            { field: "date", headerName: "Date", flex: 1 },
            { field: "inOut", headerName: "IN/OUT", flex: 1 },
            { field: "punchInOrOut", headerName: "Date IN/OUT Time", flex: 1 },
          ]
        : [];

    return activeTab === 2 ? (
      <>
        <br />
        <Box
          sx={{
            padding: (theme) => theme.spacing(2, 0),
          }}
        >
          <Formik
            initialValues={{
              fromDate: "",
              toDate: "",
            }}
            enableReinitialize
            validationSchema={validationSchemaThree}
            onSubmit={(values, { resetForm }) => {
              handleSubmitPunchAttedance(values);
            }}
          >
            {({ values, resetForm }) => {
              const today = new Date();
              const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
              const dayBeforeYesterday = new Date(
                today.getTime() - 2 * 24 * 60 * 60 * 1000
              );

              return (
                <Form>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={3}>
                      <FormikDatePicker
                        name="fromDate"
                        label="From Date"
                        required
                        views={["year", "month", "day"]}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        maxDate={dayBeforeYesterday}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <FormikDatePicker
                        name="toDate"
                        label="To Date"
                        required
                        views={["year", "month", "day"]}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        // minDate={
                        //   values?.fromDate
                        //     ? new Date(
                        //       new Date(values.fromDate).setDate(
                        //         new Date(values.fromDate).getDate() + 1
                        //       )
                        //     )
                        //     : undefined
                        // }
                        minDate={
                          values?.fromDate
                            ? new Date(values.fromDate)
                            : undefined
                        }
                        maxDate={yesterday}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} mt={3}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ mr: 2 }}
                      >
                        Submit
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        color="error"
                        onClick={() => handlePunchReset(resetForm)}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Box>
        {/* download onsite attendance excel */}
        <StyledButton
          icon={<DownloadIcon />}
          label="Download Excel"
          onClick={() => downloadExcel("download.xlsx")}
          size="small"
          variant="outlined"
          type="button"
          disabled={
            activeTab === 1
              ? !tableRows || tableRows.length === 0
              : !punchTableRows || punchTableRows.length === 0
          }
          sx={{
            // width: "185px",
            // height: "32px",
            // ml: 2,
            mb: 2,
            borderRadius: "4px",
            color: "hsl(38,92%,50%)",
            background: "rgb(253,239,214)",
            border: "1px solid hsl(38,92%,50%)",
            "&:hover": {
              color: "hsl(38,92%,50%)",
              background: "rgb(253,239,214)",
              border: "1px solid hsl(38,92%,50%)",
            },
            ...// if disabled, override styles
            ((activeTab === 1
              ? !tableRows || tableRows.length === 0
              : !punchTableRows || punchTableRows.length === 0) && {
              color: "#aaa",
              background: "#f0f0f0",
              border: "1px solid #ccc",
              cursor: "not-allowed",
            }),
          }}
        />

        <CommonDataTable
          columns={columns}
          rows={activeTab === 2 ? punchTableRows : tableRows}
          checkbox={false}
          search={false}
          loading={activeTab === 2 ? punchLoading : isLoading}
        />
      </>
    ) : activeTab === 1 ? (
      <>
        <br />
        <Box
          sx={{
            padding: (theme) => theme.spacing(2, 0),
          }}
        >
          <Formik
            initialValues={{
              empId: "",
              fromDate: "",
              toDate: "",
            }}
            enableReinitialize
            validationSchema={validationSchemaTwo}
            onSubmit={(values, { resetForm }) => {
              handleSubmitAttedance(values);
            }}
          >
            {({ values, resetForm }) => {
              const today = new Date();
              const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
              const dayBeforeYesterday = new Date(
                today.getTime() - 2 * 24 * 60 * 60 * 1000
              );

              return (
                <Form>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={3}>
                      <FormikSelectInput
                        name="empId"
                        label="Employee"
                        options={empOptions}
                        placeholder="Select Employee"
                        required
                        search
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <FormikDatePicker
                        name="fromDate"
                        label="From Date"
                        required
                        views={["year", "month", "day"]}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        maxDate={dayBeforeYesterday}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <FormikDatePicker
                        name="toDate"
                        label="To Date"
                        required
                        views={["year", "month", "day"]}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        // minDate={
                        //   values?.fromDate
                        //     ? new Date(
                        //       new Date(values.fromDate).setDate(
                        //         new Date(values.fromDate).getDate() + 1
                        //       )
                        //     )
                        //     : undefined
                        // }
                        minDate={
                          values?.fromDate
                            ? new Date(values.fromDate)
                            : undefined
                        }
                        maxDate={yesterday}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} mt={3}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ mr: 2 }}
                      >
                        Submit
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        color="error"
                        onClick={() => handleReset(resetForm)}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Box>
        {/* download onsite attendance excel */}
        <StyledButton
          icon={<DownloadIcon />}
          label="Download Excel"
          onClick={() => downloadExcel("download.xlsx")}
          size="small"
          variant="outlined"
          type="button"
          disabled={!tableRows || tableRows.length === 0}
          sx={{
            // width: "185px",
            // height: "32px",
            // ml: 2,
            mb: 2,
            borderRadius: "4px",
            color: "hsl(38,92%,50%)",
            background: "rgb(253,239,214)",
            border: "1px solid hsl(38,92%,50%)",
            "&:hover": {
              color: "hsl(38,92%,50%)",
              background: "rgb(253,239,214)",
              border: "1px solid hsl(38,92%,50%)",
            },
            ...// if disabled, override styles
            ((!tableRows || tableRows.length === 0) && {
              color: "#aaa",
              background: "#f0f0f0",
              border: "1px solid #ccc",
              cursor: "not-allowed",
            }),
          }}
        />

        <CommonDataTable
          columns={columns}
          rows={tableRows}
          checkbox={false}
          search={false}
        />
      </>
    ) : (
      <>
        <Formik
          initialValues={{
            date: null,
            file: null,
            uploadType: uploadValue,
          }}
          onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
          validationSchema={validationSchemaToUse}
        >
          {({ isSubmitting, values, setFieldValue, errors }) => {
            return (
              <Form>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: 430,
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <FormikRadioGroup
                      name="uploadType"
                      options={uploadType}
                      onChange={(e) => {
                        setUploadValue(e.target.value);
                      }}
                    />
                    {values.uploadType === "bulkUpload" && (
                      <StyledButton
                        icon={<DownloadIcon />}
                        label="Download Sample"
                        onClick={() =>
                          handleDownloadSample(
                            onSiteAttendanceSample,
                            "sample.csv"
                          )
                        }
                        size="small"
                        variant="outlined"
                        type="button"
                        sx={{
                          width: "185px",
                          height: "32px",
                          // ml: 2,
                          borderRadius: "4px",
                          color: "hsl(38,92%,50%)",
                          background: "rgb(253,239,214)",
                          border: "1px solid hsl(38,92%,50%)",
                          "&:hover": {
                            color: "hsl(38,92%,50%)",
                            background: "rgb(253,239,214)",
                            border: "1px solid hsl(38,92%,50%)",
                          },
                        }}
                      />
                    )}
                  </Box>
                  {values.uploadType === "daywise" && (
                    <FormikDatePicker
                      name="date"
                      label="Choose Date"
                      width="100%"
                      views={["year", "month", "day"]}
                      format="DD/MM/YYYY"
                      required
                      placeholder="Select Date"
                      maxDate={new Date()}
                      onChange={(event) => {}}
                    />
                  )}
                  {values.uploadType === "bulkUpload" && (
                    <FormikFileUpload
                      required
                      placeholder="Choose File"
                      name="file"
                      label="Import File"
                      handleChange={(event, file) =>
                        setFieldValue("file", file)
                      }
                    />
                  )}
                  <Box width={500}>
                    <StyledButton
                      type="submit"
                      //  label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                      label={
                        isSubmitting ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : values.uploadType === "bulkUpload" ? (
                          <>
                            <FileUploadOutlinedIcon sx={{ mr: 1 }} />
                            Import
                          </>
                        ) : (
                          "Submit"
                        )
                      }
                      variant="contained"
                    />
                  </Box>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  };

  return (
    <CardContent title={"Onsite Attendance Process"}>
      <CustomTab
        tabs={tabsData}
        value={activeTab}
        renderContent={renderContent()}
        onChange={handleTabChange}
      />
    </CardContent>
  );
};

export default OnsiteAttendanceProcess;
